
import React from 'react';
import {FormFeedback} from 'reactstrap'

import { useFormikContext, getIn } from 'formik';

const MyErrorMessage = ({ name }) => {
    const formikContext = useFormikContext();
    const touched = formikContext?.touched;
    const errors = formikContext?.errors; 

    const invalid = errors && touched && getIn(errors, name) && getIn(touched, name);
    return <FormFeedback className={invalid ? 'd-block' : null} ><h5>{getIn(errors, name)}</h5></FormFeedback>
   
}


export default MyErrorMessage; 